<template>
  <div class="section-main__warp workShopManage-page">
    <ioc-table
      ref="crud"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="searchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          v-auth="'/workShopManage:add'"
          size="small"
          icon="el-icon-plus"
          @click="handleOpenPanel"
        >
          新增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleUpdate(scope.row, 'view')"
          ></el-button>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          content="编辑"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            v-auth="'/workShopManage:update'"
            @click="handleUpdate(scope.row, 'edit')"
          >
            <i class="el-icon-edit"></i>
          </el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            v-auth="'/workShopManage:delete'"
            @click="handleDelete(scope.row)"
          >
            <i class="el-icon-delete"></i>
          </el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <!--新增修改 名单表单 -->
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="showPanel"
      @cancel="handleClosePanel"
      :title="
        formState === 1
          ? '新增车间信息'
          : formState === 2
          ? '编辑车间信息'
          : '车间详情'
      "
    >
      <el-scrollbar>
        <el-form
          :inline="true"
          ref="ruleForm"
          label-width="100px"
          :model="formData"
          style="width: calc(100% - 10px); position: relative"
          :rules="rules"
        >
          <el-form-item label="车间名称" prop="workShopName">
            <el-input
              v-model="formData.workShopName"
              :readonly="formState == 3"
              class="form-input-item"
              :maxlength="11"
              clearable
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="车间电话" prop="workShopPhone">
            <el-input
              v-model="formData.workShopPhone"
              :readonly="formState == 3"
              class="form-input-item"
              :maxlength="11"
              clearable
              :placeholder="formState == 3 ? '无' : '请输入电话号码'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="车间负责人"
            class="form-item"
            prop="directorPersonnelList"
          >
            <el-input
              :value="
                formData.directorPersonnelList
                  .map((el) => {
                    return (
                      el.directorPersonnelName +
                      '【' +
                      el.directorPersonnelPhone +
                      '】'
                    );
                  })
                  .join(',')
              "
              readonly
              :maxlength="11"
              class="form-input-item"
              placeholder="请选择负责人"
            ></el-input>
            <img
              style="
                cursor: pointer;
                position: absolute;
                top: 10px;
                right: 10px;
              "
              src="@src/common/assets/images/icon/more.png"
              @click="openPeople('1')"
              v-if="formState != 3"
              alt=""
            />
            <!-- <el-button
              type="text"
              size="small"
              v-if="formState != 3"
              class="iconfont icon-position map-choose"
              @click="openPeople('1')"
            ></el-button> -->
          </el-form-item>
          <el-form-item
            label="部门负责人"
            prop="workShopDeptManagerPersonnelList"
          >
            <el-input
              type="textarea"
              autosize
              :resize="formState == 3 ? 'none' : ''"
              class="form-input-item"
              :value="
                formData.workShopDeptManagerPersonnelList
                  .map((el) => {
                    return el.personnelName + '【' + el.personnelPhone + '】';
                  })
                  .join(',')
              "
              readonly
              placeholder="请选择部门负责人"
            ></el-input>
            <img
              style="
                cursor: pointer;
                position: absolute;
                top: 10px;
                right: 10px;
              "
              src="@src/common/assets/images/icon/more.png"
              @click="openPeople('4')"
              v-if="formState != 3"
              alt=""
            />
            <!-- <el-button
              type="text"
              size="small"
              v-if="formState != 3"
              class="iconfont icon-position map-choose"
              @click="openPeople('4')"
            ></el-button> -->
          </el-form-item>
          <el-form-item label="班组负责人" prop="workShopMonitorPersonnelList">
            <el-input
              type="textarea"
              autosize
              :resize="formState == 3 ? 'none' : ''"
              class="form-input-item"
              clearable
              :value="
                formData.workShopMonitorPersonnelList
                  .map((el) => {
                    return el.personnelName + '【' + el.personnelPhone + '】';
                  })
                  .join(',')
              "
              readonly
              placeholder="请选择班组负责人"
            ></el-input>
            <img
              style="
                cursor: pointer;
                position: absolute;
                top: 10px;
                right: 10px;
              "
              src="@src/common/assets/images/icon/more.png"
              @click="openPeople('2')"
              v-if="formState != 3"
              alt=""
            />
            <!-- <el-button
              type="text"
              size="small"
              v-if="formState != 3"
              class="iconfont icon-position map-choose"
              @click="openPeople('2')"
            ></el-button> -->
          </el-form-item>
          <el-form-item label="值班人员" prop="belongModelUrl">
            <el-input
              type="textarea"
              autosize
              :resize="formState == 3 ? 'none' : ''"
              class="form-input-item"
              clearable
              :value="
                formData.workShopPersonnelList
                  .map((el) => {
                    return el.personnelName;
                  })
                  .join(',')
              "
              readonly
              placeholder="请选择值班人员"
            ></el-input>
            <img
              style="
                cursor: pointer;
                position: absolute;
                top: 10px;
                right: 10px;
              "
              src="@src/common/assets/images/icon/more.png"
              @click="openPeople('3')"
              v-if="formState != 3"
              alt=""
            />
            <!-- <el-button
              type="text"
              size="small"
              v-if="formState != 3"
              class="iconfont icon-position map-choose"
              @click="openPeople('3')"
            ></el-button> -->
          </el-form-item>

          <el-form-item label="所属楼栋" prop="workShopBuildingList">
            <el-input
              type="textarea"
              class="form-input-item"
              autosize
              readonly
              :resize="formState == 3 ? 'none' : ''"
              clearable
              placeholder="请选择楼栋/楼层"
              :value="
                formData.workShopBuildingList
                  .map((el) => {
                    if (el.buildingName) {
                      return el.parentBuildingName + '/' + el.buildingName;
                    } else {
                      return el.parentBuildingName;
                    }
                  })
                  .join(',')
              "
            >
            </el-input>
            <el-button
              type="text"
              size="small"
              v-if="formState != 3"
              class="iconfont icon-position map-choose"
              @click="openBuilding"
            ></el-button>
          </el-form-item>

          <el-form-item label="车间说明" style="width: 100%" prop="desc">
            <el-input
              type="textarea"
              :rows="5"
              :resize="formState == 3 ? 'none' : ''"
              clearable
              maxlength="200"
              show-word-limit
              :readonly="formState == 3"
              placeholder="请输入车间说明"
              v-model="formData.desc"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-scrollbar>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePanel" :loading="subLoading">
          {{ subLoading ? "提交中" : formState === 3 ? "关闭" : "取消" }}
        </el-button>
        <el-button
          v-if="formState != 3"
          type="primary"
          :loading="subLoading"
          @click="handleSave"
        >
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
    <!-- 人员选择 -->
    <changePeople
      @confirmCallBack="confirmCallBack"
      ref="selectPeople"
      :key="key"
      :checkType="checkType"
    />
    <el-dialog
      title="楼栋选择"
      width="600px"
      v-dialogDrag
      :visible.sync="showBuilding"
    >
      <div class="flex-container">
        <div class="flex-valign left-tree">
          <div class="left-type_area sbar">
            <!-- <div class="flex-between p10 section-mian__toolbar valign-center">
              <span>所属楼栋</span>
            </div> -->
            <div class="tree-container">
              <div class="area-search">
                <el-input v-model="searchString" placeholder="请输入名称" />
              </div>
              <div class="area-scrollbar" style="height: 400px">
                <el-scrollbar style="height: 100%; padding: 20px 0">
                  <el-tree
                    v-if="showTree"
                    ref="tree"
                    class="tree-content"
                    :data="treeData"
                    show-checkbox
                    :expand-on-click-node="false"
                    node-key="buildingCode"
                    :default-expanded-keys="expandedKeys"
                    default-expand-all
                    render-after-expand
                    :props="treeProps"
                    :highlight-current="true"
                    :filter-node-method="filterNode"
                    @check="checkChange"
                  >
                    <span
                      class="custom-tree-node"
                      :title="node.label"
                      slot-scope="{ node, data }"
                    >
                      <i :class="iconList[data.type]"></i>
                      <span class="ml10 ell tree-label">{{ node.label }}</span>
                    </span>
                  </el-tree>
                </el-scrollbar>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--操作按钮-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelOpt" type="info">取消</el-button>

        <el-button type="primary" @click="confirmOpt">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import changePeople from "@src/modules/buildingConfig/components/changePeople.vue";
import tableOption from "../const/shopManageTable";
import appPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api";
import utils from "@src/common/utils";
export default {
  components: {
    appPanel,
    changePeople
  },
  filters: {
    cradTypeFilter(el) {
      return Dic.findByValue("SENU028", el) || i18n.t("personMg.label.IDNo");
    },
    sexFilter(el) {
      return Dic.findByValue("SENU062", el);
    }
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    var checkList = (rule, value, callback) => {
      if (!value || !value.length) {
        return callback(new Error("请选择人员"));
      } else {
        callback();
      }
    };
    return {
      iconList: {
        1: "iconfont-lunan icon-lunan-loudongguanli",
        2: "iconfont-lunan icon-lunan-louceng"
      },
      showBuilding: false,
      tableData: [],
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      option: tableOption(this),
      queryForm: {},
      showPanel: false,
      formState: 1, // 1：新增 2：修改
      rules: {
        workShopName: [
          { required: true, message: "请输入车间名称" },
          { max: 100, message: "长度10个字符", trigger: "blur" }
        ],
        directorPersonnelList: [
          {
            required: true,
            message: "请选择车间负责人",
            validator: checkList,
            trigger: "change"
          }
        ],
        workShopMonitorPersonnelList: [
          {
            required: true,
            message: "请选择部门负责人",
            validator: checkList,
            trigger: "change"
          }
        ],
        workShopDeptManagerPersonnelList: [
          {
            required: true,
            message: "请选择部门负责人",
            validator: checkList,
            trigger: "change"
          }
        ],
        parentBuildingName: [
          { message: "请选择所属楼栋" },
          { trigger: "change" }
        ],
        accountList: [{ message: "请选择值班人员" }, { trigger: "change" }]
      },
      formData: {
        workShopName: "",
        workShopPhone: "",
        directorPersonnelList: [],
        directorPersonnelPhone: "",
        directorPersonnelFileCode: "",
        workShopMonitorPersonnelList: [],
        workShopPersonnelList: [],
        workShopBuildingList: [],
        workShopDeptManagerPersonnelList: [],
        desc: ""
      },
      subLoading: false,
      key: 0,
      type: "",
      checkType: "select", //radio多选
      treeProps: {
        children: "subBuildingList",
        label: "buildingName",
        id: "buildingCode"
      },
      checkedKeys: [],
      expandedKeys: [],
      showTree: true,
      searchString: "",
      treeData: [],
      checkedArr: []
    };
  },

  mounted() {
    this.getListData();
    this.queryBuildingTree();
  },
  methods: {
    queryBuildingTree() {
      this.$fetch(api.queryBuildingTree).then((res) => {
        if (res.success == false) {
          this.$message.error(res.msgContent);
          return;
        }
        const result = res.returnObj;
        this.treeData = Object.freeze(result);
      });
    },
    // 批量删除
    batchDelete(data) {
      this.$confirm("此操作将永久删除该数据, 是否继续？", "删除确认", {
        confirmButtonText: this.$t("personMg.button.confirm"),
        cancelButtonText: this.$t("personMg.button.cancel"),
        type: "warning"
      }).then((res) => {
        this.$fetch(api.deleteWorkShop, {
          workShopCodeList: data ? [data.workShopCode] : this.listCodes //支持批量
        }).then((res) => {
          if (res.success) {
            this.$message.success("删除成功");
            !data ? (this.listCodes = []) : "";
            this.checkAll = false;
            this.getListData();
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    // 删除单个数据
    handleDelete(data) {
      this.batchDelete(data);
    },
    // 修改名单
    handleUpdate(data, type) {
      this.formState = 2;
      this.showPanel = true;
      this.formData.workShopName = data.workShopName;
      this.formData.workShopPhone = data.workShopPhone;
      let directObj = {};
      directObj.directorPersonnelName = data.directorPersonnelName;
      directObj.directorPersonnelPhone = data.directorPersonnelPhone;
      this.formData.directorPersonnelList.push(directObj);
      this.formData.directorPersonnelCode = data.directorPersonnelCode;
      this.formData.workShopMonitorPersonnelList =
        data.workShopMonitorPersonnelList;
      this.formData.workShopDeptManagerPersonnelList =
        data.workShopDeptManagerPersonnelList || [];
      this.formData.desc = data.desc;
      this.formData.workShopCode = data.workShopCode;
      this.formData.workShopPersonnelList = data.workShopPersonnelList.map(
        (item) => {
          return {
            personnelCode: item.personnelCode,
            personnelName: item.personnelName
          };
        }
      );
      this.formData.workShopBuildingList = data.workShopBuildingList.map(
        (item) => {
          if (item.type == "2") {
            return {
              buildingCode: item.buildingCode,
              buildingName: item.buildingName,
              parentBuildingCode: item.parentBuildingCode,
              parentBuildingName: item.parentBuildingName
            };
          } else {
            return {
              buildingCode: item.buildingCode,
              parentBuildingName: item.buildingName
            };
          }
        }
      );
      this.checkedKeys = data.workShopBuildingList.map((el) => {
        return el.buildingCode;
      });
      if (type == "view") {
        // 视图模式
        this.formState = 3;
      }
    },
    checkChange(data, checkedData) {
      this.checkedArr = checkedData.checkedNodes;
    },
    //楼栋数确认
    confirmOpt() {
      this.showBuilding = false;
      for (let i = this.checkedArr.length - 1; i >= 0; i--) {
        if (this.checkedArr[i].subBuildingList.length > 0) {
          this.checkedArr.splice(i, 1);
        }
      }
      this.formData.workShopBuildingList = this.checkedArr.map((el) => {
        return {
          buildingCode: el.buildingCode,
          buildingName: el.buildingName,
          parentBuildingName: el.parentName
        };
      });
      this.checkedKeys = this.formData.workShopBuildingList.map((el) => {
        return el.buildingCode;
      });
    },
    cancelOpt() {
      this.showBuilding = false;
      this.checkedArr = [];
    },
    //打开楼栋
    openBuilding() {
      // if (this.formState == 1) {
      //   this.formData.workShopBuildingList = [];
      //   this.checkedKeys = [];
      // }
      this.showBuilding = true;
      //选中回显
      this.$nextTick(() => {
        this.expandedKeys = this.expandedKeys.length
          ? this.expandedKeys
          : [this.treeData[0].id];
        this.$refs.tree.setCheckedKeys(this.checkedKeys || []);
      });
    },
    // 人员选择回调
    confirmCallBack(data) {
      let peopleArr = [...new Set(data)];
      let directObj = {};
      if (this.type == "1") {
        this.formData.directorPersonnelCode = peopleArr[0].personnelCode;
        directObj.directorPersonnelName = peopleArr[0].name;
        directObj.directorPersonnelPhone = peopleArr[0].phone;
        this.formData.directorPersonnelList = [directObj];
      } else if (this.type == "2") {
        this.formData.workShopMonitorPersonnelList = peopleArr.map((el) => {
          return {
            personnelName: el.name,
            personnelPhone: el.phone,
            personnelCode: el.personnelCode
          };
        });
      } else if (this.type == "3") {
        this.formData.workShopPersonnelList = peopleArr.map((el) => {
          return {
            personnelName: el.name,
            personnelCode: el.personnelCode
          };
        });
      } else {
        console.log(peopleArr);
        this.formData.workShopDeptManagerPersonnelList = peopleArr.map((el) => {
          return {
            personnelName: el.name,
            personnelPhone: el.phone,
            personnelCode: el.personnelCode
          };
        });
        console.log(this.formData.workShopDeptManagerPersonnelList);
      }
    },
    // 检索树
    filterText() {
      this.$refs.tree.filter(this.searchString.trim());
    },
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.submitData();
        }
      });
    },
    submitData() {
      this.subBtm = true;
      let workShopBuildingArr = [];
      workShopBuildingArr = this.formData.workShopBuildingList.map((el) => {
        return {
          buildingCode: el.buildingCode
        };
      });
      //值班人员
      const workShopPersonnelArr = this.formData.workShopPersonnelList.map(
        (el) => {
          return {
            personnelCode: el.personnelCode
          };
        }
      );
      //管理人员
      const workShopDeptManagerArr =
        this.formData.workShopDeptManagerPersonnelList.map((el) => {
          return {
            personnelCode: el.personnelCode
          };
        });
      const leaderPersonnelData =
        this.formData.workShopMonitorPersonnelList.map((el) => {
          return {
            personnelCode: el.personnelCode
          };
        });
      let params = {
        desc: this.formData.desc,
        workShopPhone: this.formData.workShopPhone,
        directorPersonnelCode: this.formData.directorPersonnelCode,
        workShopMonitorPersonnelList: leaderPersonnelData,
        workShopBuildingList: workShopBuildingArr,
        workShopName: this.formData.workShopName,
        workShopPersonnelList: workShopPersonnelArr,
        workShopDeptManagerPersonnelList: workShopDeptManagerArr
      };
      let url = "";
      this.formState === 1
        ? (url = api.addWorkShop)
        : ((url = api.updateWorkShop),
          (params.workShopCode = this.formData.workShopCode));
      this.$fetch(url, params).then((res) => {
        this.subBtm = false;
        if (res.success) {
          this.$message.success("操作成功");
          this.getListData();
          this.handleClosePanel();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    openPeople(type) {
      this.key += 1;
      this.type = type;
      this.type == "1"
        ? (this.checkType = "radio")
        : (this.checkType = "select");
      if (this.type == "1") {
        this.$nextTick(() => {
          let directorArr = this.formData.directorPersonnelList.map((el) => {
            return {
              name: el.directorPersonnelName,
              phone: el.directorPersonnelPhone,
              personnelCode: this.formData.directorPersonnelCode
            };
          });
          this.$refs.selectPeople.open(directorArr, "radio");
        });
      } else if (this.type == "2") {
        let workShopMonitorArr = this.formData.workShopMonitorPersonnelList.map(
          (el) => {
            return {
              name: el.personnelName,
              personnelCode: el.personnelCode,
              phone: el.personnelPhone
            };
          }
        );
        this.$nextTick(() => {
          this.$refs.selectPeople.open(workShopMonitorArr, "select");
        });
      } else if (this.type == "3") {
        let workShopPersonnelArr = this.formData.workShopPersonnelList.map(
          (el) => {
            return {
              name: el.personnelName,
              personnelCode: el.personnelCode
            };
          }
        );
        this.$nextTick(() => {
          this.$refs.selectPeople.open(workShopPersonnelArr, "select");
        });
      } else {
        console.log(this.formData);
        let workShopDeptManagerPersonnelList =
          this.formData.workShopDeptManagerPersonnelList.map((el) => {
            return {
              name: el.personnelName,
              personnelCode: el.personnelCode,
              phone: el.personnelPhone
            };
          });
        this.$nextTick(() => {
          this.$refs.selectPeople.open(
            workShopDeptManagerPersonnelList,
            "select"
          );
        });
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.buildingName.indexOf(value) !== -1;
    },
    handleResetPanel() {
      this.$refs["ruleForm"].resetFields();
      this.formData.workShopName = "";
      this.formData.directorPersonnelList = [];
      this.formData.workShopMonitorPersonnelList = [];
      this.formData.desc = "";
      this.formData.workShopPersonnelList = [];
      this.formData.workShopBuildingList = [];
    },
    handleClosePanel() {
      this.handleResetPanel();
      this.showPanel = false;
    },
    handleSwitchPanel(panelName = "showPanel", beforeFun = "handleClosePanel") {
      if (this[panelName]) {
        this[beforeFun] ? this[beforeFun]() : "";
        setTimeout(() => {
          this[panelName] = true;
        }, 600);
      } else {
        this[panelName] = true;
      }
    },
    handleOpenPanel() {
      this.formState = 1;
      this.handleSwitchPanel();
    },
    getListData() {
      let params = Object.assign(
        {
          pageSize: this.page.pageSize,
          pageNum: this.page.pageNum
        },
        this.queryForm
      );
      this.queryForm.workShopPersonnelList &&
        ((params.workShopPersonnelName = this.queryForm.workShopPersonnelList),
        delete params.workShopPersonnelList);
      this.$fetch(api.queryWorkShopList, params).then((res) => {
        if (res.success) {
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    searchChange(param) {
      this.page.pageNum = 1;
      this.queryForm = Object.assign({}, param);
      this.getListData();
    },
    handleSearchReset() {
      this.queryForm = {};
      this.getListData();
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getListData();
    }
  }
};
</script>

<style scoped lang="scss">
.app-panel {
  .el-form-item {
    width: 100%;
  }
  :deep .el-form-item__content {
    width: calc(100% - 120px);
  }
}

.map-choose {
  position: absolute;
  right: 0px;
  font-size: 18px;
  top: -3px;
}
</style>
